export const DocumentType = {
  FACILITY: 'FACILITY',
  STEP: 'STEP',
  USER: 'USER',
  GLOBAL: 'GLOBAL',
  INVOICE_TASK: 'INVOICE_TASK',
  OFFER_TASK: 'OFFER_TASK',
  TASK: 'TASK'
};